/* eslint-disable no-console */
<template>
<div>
    <div class="card z-depth-5 p-3">
        <label  v-if="parent != ''" @click="viewLesson('all')" >
            <mdb-icon icon="arrow-left" fas class="mr-2"/>
        </label>
        <h4 class="text-center font-weight-bold py-3">Missions</h4>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead class="thead-dark" :key="parent">
                    <tr>
                        <th>S/N</th>
                        <th scope="col">Title</th>
                        <th scope="col">Type</th>
                        <th scope="col">Take Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(lesson, index) in lessons" :key="lesson._id">
                        <th>{{index + 1}}</th>
                        <th>{{lesson.title}}</th>
                        <th>{{lesson.type}}</th>

                        <td>
                            <button class="btn btn-primary btn-sm" @click="editLesson(lesson)" v-if="lesson.type != 'abacus' && lesson.type != 'battle' && lesson.type != 'mental'">Edit</button>
                            <button class="btn btn-default btn-sm" @click="viewLesson(lesson._id)" v-if="lesson.type == 'abacus' || lesson.type == 'battle' || lesson.type == 'mental'">View</button>
                            <mdb-container>
                                <!-- trigger modal button -->

                                <!-- cookie modal -->
                                <mdb-modal size="lg" :show="modalEditLesson == lesson._id" removeBackdrop centered scrollable>
                                <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" @click="modalEditLesson = false">Close</button>
                                    <mdb-modal-body>
                                        <div class="card z-depth-5 p-3">
                                            <h4 class="text-center font-weight-bold py-3">Edit Mission</h4>
                                            <div>
                                                <!-- Default form login -->
                                                <form class="border border-light p-5">
                                                    <div class="row">
                                                        <div class="form-group col-md-12" v-if="!type.includes('video')">
                                                            <label>Title</label>
                                                            <input type="text" v-model="title" class="form-control mb-4" placeholder="Please input title">
                                                        </div>
                                                        <div class="form-group col-md-12" v-if="type.includes('video')">
                                                            <label>Video ID</label>
                                                            <input type="text" v-model="video" class="form-control mb-4" placeholder="Please input vimeo video id">
                                                        </div>
                                                        <div class="form-group col-md-6" v-if="!type.includes('video')">
                                                            <label>Count</label>
                                                            <input type="number" v-model="count" class="form-control mb-4" placeholder="Please input count">
                                                        </div>
                                                        <div class="form-group col-md-6" v-if="!type.includes('video')">
                                                            <label>Points</label>
                                                            <input type="number" v-model="points" class="form-control mb-4" placeholder="Please input points">
                                                        </div>
                                                    </div>

                                                    <!-- Sign in button -->
                                                    <button class="btn btn-info btn-block my-4" @click.prevent="addLesson(lesson._id)">Update Mission</button>

                                                </form>
                                                <!-- Default form login -->
                                            </div>
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" @click="modalEditLesson = false">Close</button>

                                        </div>
                                    </mdb-modal-body>
                                </mdb-modal>
                            </mdb-container>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
</template>

<style scoped>
.divider1 {
    padding: 10px;
    background: #1C2331;
    width: 80%;
    color: #fff;
}

.divider1-color {

    background: #1C2331;

}

.divider2 {
    padding: 10px;
    background: #344C6E;
    width: 80%;
    color: #fff;
}

.divider2-color {
    background: #344C6E;
}
</style>

<script>
import axios from "axios"
import {
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbIcon
} from 'mdbvue';
export default {
    name: 'Homeworks',
    components: {
        mdbContainer,
        mdbModal,
        mdbModalBody,
        mdbIcon,
    },
    data() {
        return {
            lessons: [],
            parent: this.$route.params.parent,
            modalEditLesson: false,
            lessonId: '',
            video: '',
            count: 0,
            points: 0,
            title: '',
            type: '',
            fastAdminToken : localStorage.getItem("fastAdminToken")
        }
    },
    methods: {
        editLesson(lesson) {

            this.lessonId = lesson._id;
            this.modalEditLesson = this.lessonId;

            this.title = lesson.title;
            this.video = lesson.video;
            this.count = lesson.count;
            this.points = lesson.points;
            this.type = lesson.type;

        },

        viewLesson(lessonId) {
            this.$router.push({
                name: 'Homeworks',
                params: {
                    parent: lessonId,
                }
            });
            this.initData();

        },

        addLesson(lesson_id) {
            let data = {
                title : this.title,
                video: this.video,
                count: parseInt(this.count),
                points: parseInt(this.points),
            }
            const config = {
                headers: {
                    Authorization: "Bearer " + this.fastAdminToken,
                    'Content-Type': 'application/json'
                }
            }

            this.$toast.open({
                message: "Processing : Updating Lesson Please Wait...",
                type: 'info'
            })

            axios.post(this.$apiURI + "/lessons/" + lesson_id + "/update", data, config)
                .then((response) => {
                    if (response.data.error) {
                        this.$toast.open({
                            message: "Error : " + response.data.message,
                            type: 'error'
                        });
                    } else {
                        this.$toast.open({
                            message: "Lesson Updated Successfully",
                            type: 'success'
                        })
                        this.modalEditLesson = false
                        setTimeout( window.location.reload(), 1000)
                       
                    }

                }).catch((error) => {
                    this.$toast.open({
                        message: "Error : " + error.response.data.message,
                        type: 'error'
                    });
                })
        },

        initData() {

        this.parent = this.$route.params.parent;
            
        if(this.parent == 'all') {
            this.parent = '';
        }

        this.$toast.open({
            message: "Processing : Loading Lessons Please Wait...",
            type: 'info'
        })

        const config = {
            headers: {
                Authorization: "Bearer " + this.fastAdminToken,
                'Content-Type': 'application/json'
            }
        }
        
        axios.post(this.$apiURI + "/lessons/admin", {parent: this.parent}, config)
            .then((response) => {
                if (response.data.error) {
                    this.$toast.open({
                        message: "Error : " + response.data.message,
                        type: 'error'
                    });
                } else {
                    

                    // eslint-disable-next-line no-console
                    // console.log(response.data.data.lessons)
                    this.lessons = response.data.data.lessons
                   


                }

            }).catch((error) => {
                this.$toast.open({
                    message: "Error : " + error.response.data.message,
                    type: 'error'
                });
            })
        }
    },

    mounted() {
        this.initData();
    }
}
</script>
